import React from 'react';
import { Tooltip } from 'antd';
import SgiCtnComponent from './sgiBaseComp/SgiCtnComponent';
import { convertModuleByGuid } from "./SgiCompComm";

export default class SgiTooltip extends SgiCtnComponent {
	constructor(props) {
		super(props);
	}

	__fitSonItems() {
		let { moduleDesc, objFct, type } = this.props;
		let { sonItems } = this.state;

		let cldSet = moduleDesc.cldSet || [];
		cldSet.forEach(item => sonItems.push(convertModuleByGuid(this, item, null, objFct, type)));
	}

	//渲染并返回一个虚拟DOM
	__render = () =>
		<Tooltip {...this.state._props}>
			{this.state.sonItems}
			{this.props.children}
		</Tooltip>

	__AddAttribute() {
		let { moduleDesc, parentModule } = this.props;
		let { _props, _style, _class } = this.state;

		var text = _props.te;//公共方法里已从资源获取//Resource.getTRByPrm(moduleDesc).te; //form标题
		if (text) _props.title = text;

		/**
		 * arrowPointAtCenter	箭头是否指向目标元素中心，antd@1.11+ 支持	boolean	false	
		 * autoAdjustOverflow	气泡被遮挡时自动调整位置	boolean	true	
		 * defaultVisible	默认是否显隐	boolean	false	
		 * getPopupContainer	浮层渲染父节点，默认渲染到 body 上	Function(triggerNode)	() => document.body	
		 * mouseEnterDelay	鼠标移入后延时多少才显示 Tooltip，单位：秒	number	0.1	
		 * mouseLeaveDelay	鼠标移出后延时多少才隐藏 Tooltip，单位：秒	number	0.1	
		 * overlayClassName	卡片类名	string	无	
		 * overlayStyle	卡片样式	object	无	
		 * placement	气泡框位置，可选 top left right bottom topLeft topRight bottomLeft bottomRight leftTop leftBottom rightTop rightBottom	string	top	
		 * trigger	触发行为，可选 hover/focus/click/contextMenu	string	hover	
		 * visible	用于手动控制浮层显隐	boolean	false	
		 * onVisibleChange	显示隐藏的回调	(visible) => void	无	
		 * align	该值将合并到 placement 的配置中，设置参考 rc-tooltip	Object	无	3.10.0
		 */
		if (moduleDesc.mouseEnterDelay !== undefined) _props.mouseEnterDelay = moduleDesc.mouseEnterDelay;
		if (moduleDesc.mouseLeaveDelay !== undefined) _props.mouseLeaveDelay = moduleDesc.mouseLeaveDelay;
		if (moduleDesc.placement !== undefined) _props.placement = moduleDesc.placement;
		if (moduleDesc.trigger !== undefined) _props.trigger = moduleDesc.trigger;

	}

}


// WEBPACK FOOTER //
// ./~/rt-sd-comp/sgiComp/SgiTooltip.js